import Link from '@/components/utilities/SmartLink';
import { useAppContext } from '@/components/utilities/AppContext';
import { useEbookLabels } from '@/utils/ebook-labels';

const EbookBreadcrumb = ({ title }) => {
  const labels = useEbookLabels();
  const { locale } = useAppContext();
  const homeHref = locale && locale !== 'cs' ? `/${locale}` : '/';

  return (
    <nav aria-label={labels.breadcrumbAriaLabel} className="text-grey-500 flex flex-wrap items-center gap-2 text-[13px]">
      <Link href={homeHref} className="hover:text-grey-900 transition-colors">
        Leadhub.co
      </Link>
      <span className="text-grey-400">›</span>
      <span className="text-grey-900">{title}</span>
    </nav>
  );
};

export default EbookBreadcrumb;
